<template>
    <div>
        <div id="signature-pad" :class="{ hidden: ! showPad }" class="signature-pad">
        <div class="signature-pad__body" style="width: 560px; margin: 0 auto;">
          <canvas name="signature" id="signature_pad" ref="canvas" v-on:mouseup="saveSignature()" @change="saveSignature()" @update="saveSignature()" @input="saveSignature()" :width="width" :height="height"></canvas>
        </div>
        <div class="clear"></div>
        <div class="right">
            <button class="btn btn-default m-right-20" type="button" v-on:click="clearSignature()">Clear Signature</button>
            <button v-show="!accepted" class="btn btn-success" type="button" v-on:click="acceptSignature()" :disabled="accepted">Accept Signature</button>
            <button class="btn btn-default m-right-20" type="button" v-on:click="systemGenerateSig()">System Generate Signature</button>
        </div>
        <div class="clear"></div>
      </div>
    </div>
</template>

<script>
import {defineComponent} from 'vue';
import SignaturePad from 'signature_pad';
export default defineComponent ({
    emits: ['accept', 'signed'],
    props: {
        signatureFor: {
            type: String,
            required: true
        },
        sig: {
            type: String,
            required: false
        },
        employeeFirstName: {
            type: String,
            required: false,
            default: ''
        },
        employeeLastName: {
            type: String,
            required: false,
            default: ''
        },
        employerFirstName: {
            type: String,
            required: false,
            default: ''
        },
        employerLastName: {
            type: String,
            required: false,
            default: ''
        }
    },

    data() {
        return {
            isSystemSig: false,
            pad: null,
            showPad: true,
            signature: null,
            width:540,
            height:200,
            accepted: false
        }
    },

	methods: {
        systemGenerateSig() {
            // signature_pad library can't allow to type text/type something. so we can use/modify directly
            this.clearSignature();
            let canvas = this.$refs.canvas;
            let context =  canvas.getContext('2d');
            context.font = '65px Brush Script MT';
            context.textAlign = 'center';
            context.textBaseline = 'middle'; 
            if (this.signatureFor === 'employer') {
                context.fillText(`${this.employerFirstName} ${this.employerLastName}`, this.width/2, this.height/2, this.width);
            } else {
                context.fillText(`${this.employeeFirstName} ${this.employeeLastName}`, this.width/2, this.height/2, this.width);
            }
            this.isSystemSig = true;
            this.saveSignature();
            this.accepted = true;
            this.$emit('accept', true);
        },
		acceptSignature: function() {
            if (!this.isSystemSig) {
                if (this.pad.isEmpty()) {
                    alert ("Please enter a signature");
                    return false;
                }
            }
            this.saveSignature();
            // this.showPad = false;
            this.accepted = true;
            this.$emit('accept', true);
		},
		saveSignature: function() {
            // save image as a string
			this.signature = this.pad.toDataURL();
			this.$emit('signed', this.signature);
		},
		loadSignature: function(sig) {
            this.resizeCanvas();
            this.signature = sig;
            this.pad.fromDataURL(sig);
			this.$emit('signed', this.signature);
		},
		clearSignature: function() {
            this.defaultCanvas();
			this.pad.clear();
            this.isSystemSig = false;
            this.signature = null;
            this.$emit('signed', '');
            this.accepted = false;
            this.$emit('accept', false);
		},
		defaultCanvas: function() {
            var canvas = this.$refs.canvas;
            canvas.width = this.width;
            canvas.height = this.height;
            canvas.getContext('2d').scale(1,1);
        },
		resizeCanvas: function() {
            var ratio = Math.max(window.devicePixelRatio || 1, 1);;
            var canvas = this.$refs.canvas;
            canvas.width = this.width;
            canvas.height = this.height;
            canvas.getContext('2d').scale(ratio, ratio);
            return true;
		}
	},

	mounted() {
        this.pad = new SignaturePad(this.$refs.canvas);
        this.showPad = true;
        this.pad.name = this.signatureFor;
        this.defaultCanvas();
        if (this.sig) {
            this.loadSignature(this.sig);
        }
    },
});
</script>

<style lang="css">
.signature-pad {
     position: relative;
     display: block;
     background-color: #ccc;
}
 .signature-pad button {
     float: right;
     margin-right: 10px;
     margin-bottom: 10px;
}
 .signature-pad__body canvas {
     position: relative;
     margin: 10px 10px 10px;
     background-color: #fefefe;
}
 .signature-pad__body canvas:active, .signature-pad__body canvas:hover {
     cursor: pointer;
}
</style>